var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3629_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7517 7H10.2483C8.45715 7 7 8.45715 7 10.2483V15.7518C7 17.5428 8.45715 19 10.2483 19H15.7518C17.5428 19 19 17.5428 19 15.7518V10.2483C19 8.45715 17.5428 7 15.7517 7ZM18.2965 15.7518C18.2965 17.1549 17.1549 18.2965 15.7517 18.2965H10.2483C8.84506 18.2965 7.70349 17.1549 7.70349 15.7518V10.2483C7.70349 8.84506 8.84506 7.70349 10.2483 7.70349H15.7518C17.1549 7.70349 18.2965 8.84506 18.2965 10.2483V15.7518Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8897 10.7344C11.5664 10.7344 10.4897 11.811 10.4897 13.1344C10.4897 14.4578 11.5664 15.5344 12.8897 15.5344C14.2131 15.5344 15.2897 14.4578 15.2897 13.1344C15.2897 11.811 14.2131 10.7344 12.8897 10.7344ZM12.8897 15.0198C11.8502 15.0198 11.0043 14.174 11.0043 13.1344C11.0043 12.0948 11.8502 11.2489 12.8897 11.2489C13.9294 11.2489 14.7752 12.0948 14.7752 13.1344C14.7752 14.174 13.9294 15.0198 12.8897 15.0198Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8901 10.4844C14.3514 10.4846 15.5396 11.6734 15.5396 13.1348C15.5393 14.5959 14.3513 15.784 12.8901 15.7842C11.4288 15.7842 10.24 14.596 10.2397 13.1348C10.2397 11.6733 11.4287 10.4844 12.8901 10.4844ZM12.8901 11.499C11.9886 11.499 11.2544 12.2333 11.2544 13.1348C11.2546 14.0362 11.9887 14.7695 12.8901 14.7695C13.7914 14.7693 14.5247 14.036 14.5249 13.1348C14.5249 12.2334 13.7915 11.4992 12.8901 11.499Z",
    stroke: "#737373",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8895 9.53125C15.5587 9.53125 15.2896 9.80042 15.2896 10.1312C15.2896 10.4621 15.5587 10.7313 15.8895 10.7313C16.2204 10.7313 16.4896 10.4621 16.4896 10.1312C16.4896 9.80036 16.2204 9.53125 15.8895 9.53125ZM15.8895 10.2959C15.7988 10.2959 15.7249 10.222 15.7249 10.1312C15.7249 10.0404 15.7988 9.96658 15.8895 9.96658C15.9803 9.96658 16.0542 10.0404 16.0542 10.1312C16.0542 10.222 15.9803 10.2959 15.8895 10.2959Z",
    fill: "#737373"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.4,
    stroke: "#737373",
    strokeWidth: 1.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3629_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.22bc959813ab601bdefcaf5fbeff378d.svg";
export { ForwardRef as ReactComponent };